import { useMemo } from "react";
import { DataTable } from "@/components/ui/table/data-table";
import { Icons } from "@/components/icons";
import type { ColumnDef } from "@tanstack/react-table";
import { CellAction } from "./applications-table/cell-action";
import { Mail, Calendar } from "lucide-react";
import type { OpportunityApplication } from "@/services/types";

interface ApplicationsTableProps {
  applications?: OpportunityApplication[];
  pagination?: any;
  opportunityId?: string;
}

const createColumns = (opportunityId?: string): ColumnDef<OpportunityApplication>[] => [
  {
    accessorKey: "contactPersonEmail",
    header: "Email Address",
    cell: ({ row }) => {
      const email = row.getValue("contactPersonEmail") as string;
      return (
        <div className="flex items-center space-x-2">
          <Mail className="h-4 w-4 text-gray-500" />
          <span className="truncate max-w-[200px]">{email || "-"}</span>
        </div>
      );
    },
  },
  {
    accessorKey: "contactPersonName",
    header: "Name",
    cell: ({ row }) => {
      const name = row.getValue("contactPersonName") as string;
      return <div className="font-medium text-gray-900">{name || "-"}</div>;
    },
  },
  {
    accessorKey: "createdAt",
    header: "Application Date",
    cell: ({ row }) => {
      const date = row.getValue("createdAt") as string;
      if (!date) return <div className="text-gray-600">-</div>;
      return (
        <div className="flex items-center space-x-2">
          <Calendar className="h-4 w-4 text-gray-500" />
          <span className="text-sm text-gray-600">
            {new Date(date).toLocaleDateString("en-US", {
              year: "numeric",
              month: "short",
              day: "numeric",
            })}
          </span>
        </div>
      );
    },
  },
  {
    id: "actions",
    header: "Actions",
    cell: ({ row }) => (
      <CellAction data={row.original} opportunityId={opportunityId} />
    ),
    enableSorting: false,
    enableHiding: false,
  },
];

const ApplicationsTable = ({
  applications = [],
  pagination,
  opportunityId,
}: ApplicationsTableProps) => {
  const columns = useMemo(() => createColumns(opportunityId), [opportunityId]);

  const totalItems = pagination?.totalDocs || applications.length;
console.log(applications,'applications')
  return (
    <div className="space-y-4 bg-white">
      <div className="px-4">
        <DataTable
          columns={columns}
          data={applications}
          totalItems={totalItems}
          emptyState={
            <div className="flex h-full w-full flex-col items-center justify-center">
              <Icons.emptyState />
              No applications found
            </div>
          }
        />
      </div>
    </div>
  );
};

export default ApplicationsTable;
